// Палитра состояний варианта ответа квиза — порт плеерного `blockPalette.ts`
// (academy-frontend `.../CourseProcessModal/blocks/blockPalette.ts`). Один
// источник на карточку варианта, чип fill_blank, слот пропуска и плашку
// сопоставления: в плеере все четыре красятся одной функцией `optionStyle`.
import type { CSSProperties } from 'react'
import { blockTheme } from './blockTheme'

export type QuizOptionState = 'idle' | 'selected' | 'correct' | 'incorrect'

type ActiveState = Exclude<QuizOptionState, 'idle'>

const q = blockTheme.quiz

/** Акцент состояния: заливка индикатора варианта (`STATE_COLOR`). */
export const quizStateColor = (state: QuizOptionState): string | null =>
  state === 'idle'
    ? null
    : { selected: q.primary, correct: q.success, incorrect: q.destructive }[state]

// Активные состояния — мягкая заливка без рамки (рамка прозрачная, геометрия не
// меняется), тёмный текст и своя тень: выбранный «вдавлен», верный «приподнят»,
// неверный плоский.
const ACTIVE: Record<ActiveState, CSSProperties> = {
  selected: {
    backgroundColor: q.primarySoft,
    borderColor: 'transparent',
    color: q.selectedInk,
    boxShadow: q.selectedShadow,
  },
  correct: {
    backgroundColor: q.successSoft,
    borderColor: 'transparent',
    color: q.successInk,
    boxShadow: q.successShadow,
  },
  incorrect: {
    backgroundColor: q.destructiveSoft,
    borderColor: 'transparent',
    color: q.destructiveInk,
    boxShadow: 'none',
  },
}

/** Inline-стиль варианта (`optionStyle`): idle — светлая карточка с тонкой
 *  рамкой и мягкой тенью. Толщину и тип рамки задаёт класс потребителя. */
export const quizOptionStyle = (state: QuizOptionState): CSSProperties =>
  state === 'idle'
    ? {
        backgroundColor: q.bg,
        borderColor: q.idleBorder,
        color: q.optionText,
        boxShadow: q.idleShadow,
      }
    : ACTIVE[state]
